import { useCohort } from "@/components/user-context";
import { useFeatureExposed } from "@/utils/feature-exposed";
import { useIsMobile } from "@/utils/useIsMobile";

import { SignupDefault } from "../../../components/signup-default";
import { LoggedInLoomExistingSitesUser } from "../existing-sites-user";
import { LoggedInLoomNewUser } from "../new-user";

export const LoggedInLoom = () => {
    const cohort = useCohort();
    const isMobile = useIsMobile(800);

    const isManagedUser = cohort === "managed-user";
    const isweekOneUser = cohort === "week-one-user";
    const isUpgradeEligibleUser = cohort === "upgrade-eligible-user";

    useFeatureExposed("gwp-7282-loom-lofi-signup", "Test", {
        conditions: [
            cohort !== undefined &&
                !isManagedUser &&
                !isweekOneUser &&
                !isUpgradeEligibleUser &&
                !isMobile
        ],
        metadata: {
            cohort,
            userType: "logged-in"
        }
    });

    // Default cohorts not part of loom lofi background
    if (cohort === undefined) {
        return null;
    } else if (
        cohort === "managed-user" ||
        cohort === "week-one-user" ||
        cohort === "upgrade-eligible-user"
    ) {
        return <SignupDefault />;
    } else if (isMobile) {
        return <SignupDefault />;
    }

    if (cohort === "new-user") {
        return <LoggedInLoomNewUser />;
    }

    return <LoggedInLoomExistingSitesUser />;
};
